module.controller('sampleSignFormCtrl', [ '$document', '$timeout', '$scope', '$state', 'planSamplingService', 'alertService', 'dateUtilService', 'ASEBIOL_CONSTANTS',
		'FileUploader', 'Upload', sampleTaskSignFormCtrlFn ])

function sampleTaskSignFormCtrlFn($document, $timeout, $scope, $state, planSamplingService, alertService, dateUtil, ASEBIOL_CONSTANTS, FileUploader, Upload) {
	var vm = this;
	
	vm.loading = false;
	vm.samples = [];
	
	vm.validation = {
		clientName : {
			maxlength : 200
		}
	};

	vm.pagination = {
			current : 1,
			total : 0
	};
	
	vm.takenInfo = {};
	
	vm.signature = {
		isEmpty : true
	}

	vm.widthSignature = 1900;

	vm.isCollapse = true;

	var duration = 1000; // milliseconds
	var offset = 40;

	function init() {
		loadSamples();
	}
	
	function loadSamples() {
		var filter = {};
		var page = vm.pagination.current;

		var ps = 100;
		filter.offset = (page - 1) * 100;
		filter.limit = 100;

		filter.state = [ SAMPLE_STATE.TAKEN_NOT_SIGNED.enumName ];

		// solo los planes de mmuestreo que no esten anulados
		filter['planSampling.state.notin'] = PLAN_SAMPLING_STATE.ANNUL.enumName;
		filter.orderby = [ "scheduleDate asc" ];

		planSamplingService.searchByProfessionalSamplingBasicInfo(filter).then(function(response) {
			var result = response.getData();
			vm.samples = result.results;

			vm.pagination.total = result.totalRegisters;

			vm.samples.forEach(function(s) {
				s.scheduleDate = dateUtil.formatMomentDateTime(s.scheduleDate);
				s.className = getConstantById(SAMPLE_STATE, s.state).className;
				s.tipClient = {};
			});

		}, function(response) {
		});
	}
	

	function signSample() {
		var scopeChild = $scope.$$childTail;
		if (!$scope.$$childTail.accept)
			scopeChild = $scope.$$childHead;
		vm.signature = scopeChild.accept();
		var signSamplingForm = scopeChild.signSamplingForm;
		if (!scopeChild.submitted)
			return;

		if (signSamplingForm.$invalid || vm.signature.isEmpty || angular.isUndefined(vm.signature.dataUrl)) {
			alertService.showSwtWarningQuestionRaw('Error en el formulario', 'por favor verifique la información', false, undefined);
			return;
		}

		var signModel = {
			signature: vm.signature.dataUrl,
			clientName: vm.takenInfo.clientName,
			identification_num: vm.takenInfo.identification_num,
			idSamples: []
		}
		
		signModel.idSamples = vm.samples.map(function(sample){ console.log(sample);return sample.id});
		
		if(signModel.idSamples.length == 0){
			alertService.showSwtWarningQuestionRaw('Sin muestras', 'No hay muestras para firmar', false, undefined);
			return;
		}
		
		alertService.showSwtQuestion('Aprobar muestreo', function() {
			vm.loading = true;
			planSamplingService.signSamples(signModel).then(function(response) {
				alertService.showSuccess('Muestreo aprobado');
				
				vm.loading = false;
				$state.go('home.professionalSamplingTask.sample');
			}, function(response) {
				vm.loading = false;
			});
		});

	}

	
	/*
	 * submit button
	 */
	vm.OnSubmit = function() {
		signSample();
	}

	vm.getURLDataFromImage = function() {
		if (vm.takenInfo.takePhoto) {
			var file = Upload.base64DataUrl(vm.takenInfo.takePhoto);

			file.then(function(response) {
				vm.takenInfo.takePhoto.urlData = response;
				vm.loadPhoto = false;
			});
		} else {
			vm.loadPhoto = false;
		}
	}



	init();

}
